<template>
  <div class="place-order">
    <div class="bg-white text-center py-3 shadow border-bottom">
      <router-link to="">
        <logo height="60" />
      </router-link>
    </div>
    <div class="container mt-3">
      <router-link :to="{ name: 'place-order' }" class="btn btn-primary"
        ><i class="fal fa-arrow-left"></i>Back To Order</router-link
      >
      <div class="row mt-3">
        <div class="col-9" id="order_form">
          <div class="accordion payment-accordion" id="order-accordion">
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed">
                  <i class="fal fa-info-circle"></i> Order Details
                </button>
                <button
                  class="d-none"
                  id="details-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse-details"
                  aria-expanded="true"
                  aria-controls="collapse-details"
                ></button>
              </h2>
              <div
                id="collapse-details"
                class="accordion-collapse collapse show"
                data-bs-parent="#order-accordion"
              >
                <div class="accordion-body">
                  <div class="row">
                    <div class="col-md-6">
                      <label>Content Type</label>
                      <p>{{ order.type.name }}</p>
                    </div>
                    <div class="col-md-6">
                      <label>Content Category</label>
                      <p>{{ order.category.name }}</p>
                    </div>
                    <div class="col-md-12">
                      <label>Title</label>
                      <p>{{ order.title }}</p>
                    </div>
                    <div class="col-md-12">
                      <label>Instructions</label>
                      <p>{{ order.instructions }}</p>
                    </div>
                    <div class="col-md-12" v-if="order.examples.length > 0">
                      <label>Examples</label>
                      <div class="row">
                        <div
                          class="col-md-6"
                          v-for="(example, i) in order.examples"
                          :key="`example-${i}`"
                        >
                          <p>{{ example }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12 text-end">
                      <a
                        href="#"
                        class="btn btn-primary"
                        @click.prevent="proceed(2)"
                        >Proceed <i class="fa fa-arrow-right me-0 ms-2"></i
                      ></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed">
                  <i class="fal fa-wallet"></i> Billing Information
                </button>
                <button
                  class="d-none"
                  type="button"
                  id="billing-button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse-billing"
                  aria-expanded="false"
                  aria-controls="collapse-billing"
                ></button>
              </h2>
              <div
                id="collapse-billing"
                class="accordion-collapse collapse"
                data-bs-parent="#order-accordion"
              >
                <div class="accordion-body">
                  <form @submit.prevent="validateBilling" id="billing_form">
                    <div class="row">
                      <div class="col-md-6 mb-2">
                        <label>First Name</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="First Name"
                          v-model="billing.first_name"
                          name="first_name"
                        />
                      </div>
                      <div class="col-md-6 mb-2">
                        <label>Last Name</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Last Name"
                          v-model="billing.last_name"
                          name="last_name"
                        />
                      </div>
                      <div class="col-md-12 mb-2">
                        <label>Address</label>
                        <textarea
                          rows="3"
                          class="form-control"
                          v-model="billing.address"
                          placeholder="Address"
                          name="address"
                        ></textarea>
                      </div>
                      <div class="col-md-6 mb-2">
                        <label>City</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="City"
                          v-model="billing.city"
                          name="address"
                        />
                      </div>
                      <div class="col-md-6 mb-2">
                        <label>Zip Code</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Zip Code"
                          v-model="billing.zip_code"
                          name="zip_code"
                        />
                      </div>
                      <div class="col-md-6 mb-2">
                        <label>Country</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Country"
                          v-model="billing.country"
                          name="country"
                        />
                      </div>
                      <div class="col-md-12 mb-2">
                        <a
                          href="#"
                          class="btn btn-warning"
                          @click.prevent="proceed(1)"
                          ><i class="fa fa-arrow-left"></i>Back</a
                        >
                        <button class="btn btn-primary float-end">
                          Proceed<i class="fa fa-arrow-right me-0 ms-2"></i>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button">
                  <i class="far fa-money-check-edit-alt"></i> Order Payment
                </button>
                <button
                  class="d-none"
                  type="button"
                  id="pay-button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapse-pay"
                  aria-expanded="false"
                  aria-controls="collapse-pay"
                ></button>
              </h2>
              <div
                id="collapse-pay"
                class="accordion-collapse collapse"
                data-bs-parent="#order-accordion"
              >
                <div class="accordion-body">
                  <h4>Pay with PayPal.</h4>
                  <div class="py-3">
                    <h2><strong>Amount:</strong> $ {{ total }}</h2>
                  </div>
                  <div>
                    <a
                      href="#"
                      class="btn btn-warning"
                      @click.prevent="proceed(2)"
                      ><i class="fa fa-arrow-left"></i>Back</a
                    >
                    <a
                      href="#"
                      class="btn btn-primary float-end"
                      @click.prevent="submit"
                      ><i class="fal fa-save"></i>Proceed</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card sticky-top" style="top: 15px">
            <div class="card-body">
              <h4><i class="far fa-shopping-cart"></i> My Order</h4>
              <hr />
              <div>
                <p class="mb-0">
                  <strong class="me-2">Quality:</strong>
                  <quality :quality="order.quality" />
                </p>
                <p>{{ order.quality.name }}</p>
              </div>
              <div>
                <p class="mb-0">
                  <strong class="me-2">Word Count:</strong>
                </p>
                <p>Min: {{ order.min }}, Max: {{ order.max }}</p>
              </div>
              <div>
                <p class="mb-0">
                  <strong class="me-2">Estimated Delivery:</strong>
                </p>
                <p>48 Hours</p>
              </div>
              <hr />
              <div>
                <h3>Total: ${{ total }}</h3>
              </div>
              <hr />
              <div class="mt-4">
                <api-image src="defaults/payments.png" class="w-100" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer class="footer bg-white">
      <div class="container-fluid">
        <div class="row text-muted">
          <div class="col-8 text-start">
            <ul class="list-inline">
              <li class="list-inline-item">
                <a class="text-muted" href="#">Support</a>
              </li>
              <li class="list-inline-item">
                <a class="text-muted" href="#">Privacy</a>
              </li>
              <li class="list-inline-item">
                <a class="text-muted" href="#">Terms of Service</a>
              </li>
              <li class="list-inline-item">
                <a class="text-muted" href="#">Contact</a>
              </li>
            </ul>
          </div>
          <div class="col-4 text-end">
            <p class="mb-0">
              &copy; 2024 -
              <a class="text-muted" href="#">SEOVINES</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  mounted() {
    if (!this.$storage.has("token")) {
      return this.$router.push({ name: "login" });
    }

    this.order = JSON.parse(this.$storage.get("order"));
  },

  data() {
    return {
      order: {
        type: {},
        category: {},
        quality: {},
        min: 100,
        max: 100,
        examples: ["", ""],
        title: "",
        instructions: "",
      },
      billing: {},
    };
  },

  methods: {
    proceed(step) {
      if (step == 1) {
        document.getElementById("details-button").click();
      } else if (step == 2) {
        document.getElementById("billing-button").click();
      } else if (step == 3) {
        document.getElementById("pay-button").click();
      }
    },

    validateBilling() {
      let data = this.billing;
      data.form_id = "billing_form";

      this.$axios
        .post("/api/v1/dashboard/orders/validate-billing", data)
        .then(() => {
          this.proceed(3);
        });
    },

    submit() {
      let data = {
        form_id: "order_form",
        order: {
          type_id: this.order.type.id,
          category_id: this.order.category.id,
          quality_type_id: this.order.quality.id,
          title: this.order.title,
          instructions: this.order.instructions,
          min: this.order.min,
          max: this.order.max,
          examples: this.order.examples,
        },
        billing: this.billing,
      };

      this.$axios.post("/api/v1/dashboard/orders", data).then((response) => {
        // this.$storage.remove('order')
        window.location.href = response.data.url
      });
    },
  },

  computed: {
    price_per_word() {
      return this.order.quality.price / this.order.quality.words;
    },

    total() {
      return Math.round(this.price_per_word * this.order.max, 2);
    },
  },
};
</script>
